import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function ScarletSplendour() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>From Niche to Global Preference: A 400% Rise in Architect & Interior Designer Leads for Scarlet Splendour</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">SCARLET</span> SPLENDOUR</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst circleboxfirst-relative  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> From Niche to Global Preference: </span><br />  A 400% Rise in Architect & Interior Designer Leads for Scarlet Splendour  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> From Niche to Global Preference: </span>  <br />  A 400% Rise in Architect & Interior Designer Leads for Scarlet Splendour  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Scarlet Splendour is a global luxury furniture and design brand celebrated for its dramatic, art-meets-function creations. From Milan to Mumbai, it is known for:
                            </p>
                            <p className="">
                                1. Collectable craftsmanship and artistic storytelling
                            </p>
                            <p className="">
                                2. Collaborations with some of the world’s most avant-garde designers
                            </p>
                            <p className="">
                                3. A bold, maximalist aesthetic that redefines Indian luxury on a global stage
                            </p>
                            <br></br>
                            <br></br>
                        </Col>

                        <Col lg={{ span: 5 }} md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <br></br>
                            <br></br>
                           
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/scarlet-brand.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div id="letsdo" className="seoapproach bgbl padmmdt padmmdb ">
                <Container>

                    <Row>
                        <Col sm={12}>
                            <p className="text-center p1 mrg30 " > <span class="spcase">THE</span> <strong>CHALLENGE</strong>  </p>
                        </Col>
                         <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>Despite substantial brand equity and a striking product line, Scarlet Splendour was not seeing the digital momentum it deserved. Key challenges included:</p>
                            <br></br>
                            <br></br>
                        </Col>
                         <Col md={2} lg={2}></Col>

                    </Row>

                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Inbound </strong><br /> <i>Leads </i></h4>
                            <p>Low monthly inbound leads</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>Minimal,  </strong><br /> <i>Traction</i></h4>
                            <p>Minimal traction from architects and interior designers</p>
                        </div>

                        <div className="bottom-left">
                            <h4> <strong>Digital</strong><br /> <i>Presence</i></h4>
                            <p>Limited digital presence outside India</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Marquee </strong><br /> <i>Events</i></h4>
                            <p>Underutilization of marquee events like Milan Design Week and India Design ID for lead generation</p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>

                     <div className="appbox  padssmb d-block d-sm-none">
                        <h1>The <span>Challenge</span></h1> <br />

                        <h4><strong> Inbound </strong><br /> <i>Leads </i></h4>
                        <p>Low monthly inbound leads</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Minimal  </strong><br /> <i>Traction</i></h4>
                        <p>Minimal traction from architects and interior designers</p>

                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Digital</strong><br /> <i>Presence</i></h4>
                        <p>Limited digital presence outside India</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Marquee </strong><br /> <i>Events</i></h4>
                        <p>Underutilization of marquee events like Milan Design Week and India Design ID for lead generation</p>
                    </div>


                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>The brand approached A&B to help build a high-conversion pipeline of qualified luxury leads — both B2C and B2B — and to establish itself as a digitally powerful global luxury brand.</p>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>

                </Container>
                {/* <img src={`${process.env.PUBLIC_URL}/img/approach.png`} className="img-fluid" /> */}
            </div>


            <div className="bgbl casestudy">
                <Container>
                    <Row>
                    <Col sm={12}>
                        <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong style={{color:'#fff'}}>PROCESS</strong>  </p>
                    </Col>
                </Row>
                <Process />
                </Container>
               
            </div>

            <div className="lgbox  problem padbxsb">
                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>
                        </Col>
                        <Row>
                            <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                <div id="iwantto" className="seomatters casestudyimpacts bgb">
                                    <Container className="padbmdt padbmdb">
                                        <p>Our partnership led to a dramatic turnaround in Scarlet Splendour’s inbound pipeline:</p>
                                        <br></br>
                                        <br></br>
                                        <Row className="padsmdb">
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Lead <br></br> Growth <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>24x increase in leads/month</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Lead <br></br> Quality <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>43% of leads qualify as UHNI/HNI clients</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Event <br></br> ROI <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>250+ RSVPs captured per event via targeted digital campaigns</p><br />
                                            </Col>
                                         
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Architects & <br></br> Interior Designers <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>A dependable, high-quality Architect & Interior Designer lead engine that consistently fuels long-term, high-value projects making Scarlet Splendour a go-to brand within the global design community.</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Global <br></br> Expansion <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>substantial international leads/month, after rolling out global campaigns leveraging the European designers. </p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{fontSize:20}} className="">Prestigious <br></br> Clientele <br /><br /></h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'>Closed leads from the most prominent families of India who own multi-billion dollar homes, IPL owners and top-tier architect/interior studios.</p><br />
                                            </Col>
                                            
                                        </Row>
                                         <AnchorLink href="" className="btn btn-seo" >Let's Get More Sales </AnchorLink>

                                    </Container>
                                </div>
                            </Col>
                        </Row>
                    </Row>

                </Container>
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default ScarletSplendour;

function Process() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    adaptiveHeight: true,
                }
            },],
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    adaptiveHeight: false,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        // <Container fluid className="reasons padslgt padslgb casestudy ">
        <Container fluid className="reasons padslgb casestudy ">
            <Row>
                <Col lg="10" className="offset-lg-1">
                    <Slider {...settings}>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >

                                    <h2 className="padt190"><span>OSIDE Targeting</span></h2>
                                    <h3 className=" padmsmb">Mapped affluent locations and luxury lifestyle segments using A&B’s proprietary tool, creating high-affinity audiences for lead targeting.</h3>

                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_1.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Architect & Interior Designer Growth</span></h2>
                                    <h3 className=" padmsmb"> Built a clear B2B acquisition roadmap: segmented high-value architects & designers, created tailored funnels for repeat, design-led projects, and established an always-on lead pipeline.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_2.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Sales Enablement</span></h2>
                                    <h3 className=" padmsmb"> Implemented WhatsApp Business for real-time lead delivery, enabling the sales team to engage instantly with qualified prospects.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_3.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Event-Led Campaigns</span></h2>
                                    <h3 className=" padmsmb"> Ran targeted pre- and post-event campaigns around Milan Design Week, India Design ID, and Ajio Luxe — turning awareness into high-quality leads.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
}